import React from 'react'
import {Icon} from '@chakra-ui/react'

const GridIconB = (props) => {
    return (
        <Icon viewBox="0 0 40 40" fill="none" {...props}>
            <g clipPath="url(#clip0_541_1395)">
                <rect
                    x="3.5"
                    y="9.16669"
                    width="13.1667"
                    height="21.6667"
                    rx="0.5"
                    stroke="currentColor"
                />
                <rect
                    x="30.417"
                    y="14.8333"
                    width="6.08333"
                    height="10.3333"
                    rx="0.5"
                    fill="currentColor"
                    stroke="currentColor"
                />
                <rect
                    x="21.917"
                    y="14.8333"
                    width="6.08333"
                    height="10.3333"
                    rx="0.5"
                    fill="currentColor"
                    stroke="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_541_1395">
                    <rect width="34" height="34" fill="currentColor" transform="translate(3 3)" />
                </clipPath>
            </defs>
        </Icon>
    )
}

export default GridIconB
